"use client";
import "./LoadingImage.css";

interface LoadingImageProps {
  width?: string;
  height?: string;
  backgroundColor?: string;
  className?: string;
}

const LoadingImage: React.FC<LoadingImageProps> = ({ className = '', width = '100%', height = '100%', backgroundColor = '#6660' }) => {
    return (
        <div className={`image-loading-container ${className}`} style={{ width, height, backgroundColor }}>
        </div>
    );
}

export default LoadingImage;